import { UseQueryResult } from '@tanstack/react-query';
import { CollapseProps, Descriptions, Grid, Typography } from 'antd';
import { AxiosResponse } from 'axios';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import CollapseCustom from 'src/components/v2/Collapse';
import { HRTicketStatusTag } from 'src/components/v2/Tag/TicketStatusTag/TicketStatusTag';
import urlPath from 'src/constants/urlPath';
import { ILeaveTicket } from 'src/types/hr_ticket/leaveTicket.type';
import { formatDateTime } from 'src/utils/utils';
const { Text } = Typography;

const leaveTicketItems = (leaveTickets: ILeaveTicket[], colspan: number): CollapseProps['items'] => {
  return leaveTickets.map((item) => ({
    key: item.id,
    label: (
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        key={item.id}
      >
        <Descriptions.Item label='Mã'>
          <Link to={`${urlPath.myAdditionalWorkingTimeTicket.location}/${item.id}`}>{item.code}</Link>
        </Descriptions.Item>
        <Descriptions.Item label='Trạng thái'>
          <HRTicketStatusTag
            ticketStatus={item.ticketStatus}
            erpKey={item.erpKey}
            hrConfirmedType={item.hrConfirmedType}
          />
        </Descriptions.Item>
        <Descriptions.Item label='Người lập phiếu'>
          <Text>{item.createdBy?.fullName}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày tạo'>
          <Text>{formatDateTime(item?.createdDate)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ghi chú' span={colspan}>
          <Text>{item.note}</Text>
        </Descriptions.Item>
      </Descriptions>
    ),
    className: 'leave-ticket-collapse-item',
    showArrow: false
  }));
};

export default function LeaveTicket(
  refLeaveTicketsForTicketQuery: UseQueryResult<AxiosResponse<ILeaveTicket[], any>, unknown>
) {
  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  return (
    <Fragment>
      {refLeaveTicketsForTicketQuery?.data?.data && refLeaveTicketsForTicketQuery?.data?.data.length > 0 && (
        <CollapseCustom
          isFullDefault
          title='Danh sách nghỉ phép'
          titleLevel={5}
          isSegmented={false}
          collapsible='disabled'
          items={leaveTicketItems(refLeaveTicketsForTicketQuery?.data.data || [], colspan)}
          expandIconPosition='end'
          className='leave-ticket-collapse'
        />
      )}
    </Fragment>
  );
}
